import { render, staticRenderFns } from "./dashboard-archived.vue?vue&type=template&id=2d77437e&"
import script from "./dashboard-archived.vue?vue&type=script&lang=ts&"
export * from "./dashboard-archived.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-archived.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports